"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOLMap = void 0;
const react_1 = require("react");
const MapContext_1 = require("../MapContext");
function useOLMap() {
    const { map } = react_1.useContext(MapContext_1.MapContext);
    return map;
}
exports.useOLMap = useOLMap;
//# sourceMappingURL=useOLMap.js.map